import { createSlice } from "@reduxjs/toolkit";

// Define the initial state using that type
const initialState: IRackState = {
  data: null,
  pageSize: 0,
  pageNumber: 0,
  totalCount: 0,
  showLoading: {
    sourceAction: "",
    state: false,
  },
  isLoading: false,
  isSuccess: false,
  details: null,
  rackManagerDetails: null,
  chassisManagerDetails: null,
  bulkLeaseResult: {
    result: null,
    showResult: false,
  },
};

export const rackSlice = createSlice({
  name: "rack",
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    setLoading: (state, action) => {
      const { isLoading, isSuccess } = action.payload;
      state.showLoading = {
        sourceAction: action.payload.sourceAction,
        state: true,
      };
      state.isLoading = isLoading ? isLoading : false;
      state.isSuccess = isSuccess ? isSuccess : false;
    },
    resetLoading: (state, action) => {
      const { isLoading, isSuccess } = action.payload;
      state.showLoading = {
        sourceAction: "",
        state: false,
      };
      state.isLoading = isLoading ? isLoading : false;
      state.isSuccess = isSuccess ? isSuccess : false;
    },
    replaceRack: (state, action) => {
      const { data, pageSize, pageNumber, totalCount } = action.payload;
      state.data = data;
      state.pageSize = pageSize;
      state.pageNumber = pageNumber;
      state.totalCount = totalCount;
    },
    addRack: (state, action) => {
      const newItem = action.payload.data;
      if (state.data && state.data.length > state.pageSize) {
        state.data.pop();
      }
      state.data = state.data ? [newItem, ...state.data] : [newItem];
      state.totalCount = state.totalCount + 1;
    },
    updateRack: (state, action) => {
      const { localID, data } = action.payload;
      if (localID !== undefined && localID >= 0 && state.data) {
        state.data[localID] = data;
      }
      state.details = data;
    },
    deleteRack: (state, action) => {
      const rackToRemove: IRackInt = action.payload.data;
      const newrackData =
        state.data &&
        state.data.filter((rack: IRackInt) => {
          return rack.id !== rackToRemove.id;
        });
      state.data = newrackData;
      state.totalCount = state.totalCount - 1;
    },
    setRackDetails: (state, action) => {
      state.details = action.payload.data;
    },
    setRMManagerDetails: (state, action) => {
      state.rackManagerDetails = action.payload.data;
    },
    setCMManagerDetails: (state, action) => {
      state.chassisManagerDetails = action.payload.data;
    },
    setBulkLeaseResult: (state, action) => {
      const { result, showResult } = action.payload;
      state.bulkLeaseResult = { result: result, showResult: showResult };
    },
  },
});

export const rackActions = rackSlice.actions;

export default rackSlice.reducer;
